import { render, staticRenderFns } from "./TemplateStepGrupoFamiliar.vue?vue&type=template&id=22ed487b&scoped=true"
import script from "./TemplateStepGrupoFamiliar.vue?vue&type=script&lang=js"
export * from "./TemplateStepGrupoFamiliar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed487b",
  null
  
)

export default component.exports